import React from 'react'
import { History } from '@mui/icons-material'
import { IconButton, useTheme } from '@mui/material'
import { useControls } from 'react-zoom-pan-pinch'

export const RevertButtonControl = () => {
  const { resetTransform, centerView } = useControls()
  const theme = useTheme()

  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation()
        resetTransform(0)
        centerView(undefined, 0)
        e.currentTarget.blur()
      }}>
      <History htmlColor={`${theme.palette.secondary.main}`} />
    </IconButton>
  )
}
